module.exports = __webpack_public_path__ + "static/img/plaques_autochromes.499ada0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/plaques_autochromes.jpg
// module id = 33
// module chunks = 0